// Entrypoint for the guest-facing modern layout (layouts/public_modern, LW-272).
//
// Almost nothing by design: its job is to pull in the public Tailwind bundle so
// vite_ruby emits the stylesheet, plus the same anti-FOUC reveal the admin shell
// uses. There is deliberately no port of modern.js here — sidebar, topbar
// dropdowns, the theme toggle, notification bulk-actions and clickable table
// rows are all CRM chrome a public page has no markup for, and shipping ~900
// lines of it to a guest arriving from an SMS link buys nothing.
//
// Genuine interactivity on a public page belongs in an island (islands.js is
// loaded alongside this by the layout), not here.
import '~/styles/public.css'

// In dev, Vite injects the stylesheet via JS *after* first paint. The layout
// hides <body> while `lw-loading` is set; the CSS import above has been evaluated
// by the time this runs, so rAF waits for the styles to apply and then reveals.
// The layout also reveals on `load`/timeout in case this never runs.
requestAnimationFrame(() => document.documentElement.classList.remove('lw-loading'))
